// src/passwordless.js
import { signInWithEmailLink, sendSignInLinkToEmail, isSignInWithEmailLink } from 'firebase/auth';
import { auth } from './firebase';

const actionCodeSettings = {
  url: 'https://logistoria-platform.vercel.app/',
  handleCodeInApp: true,
};

export async function sendMagicLink(email) {
  await sendSignInLinkToEmail(auth, email, actionCodeSettings);
  window.localStorage.setItem('emailForSignIn', email);
}

export async function completeMagicLinkSignIn() {
  try {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) email = window.prompt('Подтвердите свой e-mail для входа:');
      const res = await signInWithEmailLink(auth, email, window.location.href);
      window.localStorage.removeItem('emailForSignIn');
      return res.user;
    }
  } catch (e) {
    console.warn('Magic link error', e);
  }
  return null;
}
